export default __webpack_public_path__ + "static/media/39.7c92af7c.jpeg";